export default __webpack_public_path__ + "ce26aa1a9daf36a98ecf554222d403c4.png";